import React, { Component } from 'react';
import { TouchableWithoutFeedback, View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './Option.styles';

class Option extends Component {
  render() {
    const {
      mainTitle,
      mainTitleTextStyle,
      subTitle,
      subTitleTextStyle,
      isActive,
      index,
      selectOption,
      containerStyle,
      theme,
    } = this.props;

    return (
      <TouchableWithoutFeedback onPress={() => selectOption(index)}>
        <View style={[styles.containerStyle(theme, isActive, subTitle), containerStyle]}>
          <VFText style={[styles.mainTitle, mainTitleTextStyle]} i18nKey={mainTitle} />
          {subTitle && <VFText style={[styles.subTitle, subTitleTextStyle]} i18nKey={subTitle} />}
        </View>
      </TouchableWithoutFeedback>
    );
  }
}

Option.defaultProps = {
  isActive: false,
  selectOption: () => {},
  theme: LightThemeColors,
};

Option.propTypes = {
  mainTitle: PropTypes.string,
  mainTitleTextStyle: PropTypes.object,
  subTitle: PropTypes.string,
  subTitleTextStyle: PropTypes.object,
  isActive: PropTypes.bool,
  index: PropTypes.number,
  selectOption: PropTypes.func,
  containerStyle: ViewPropTypes.style,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(Option);
